import client from "../libs/HttpClient";

class BrochureServices {
  static brochureList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/brochure?page=${page_no}`, request);
  }
  static addBrochure(request) {
    return client.post(`/add-brochure`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateBrochure(request) {
    return client.post(`/edit-brochure`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewBrochure(params) {
    return client.get(`/get-brochure`, { params });
  }
  static deleteBrochure(params) {
    return client.delete(`/delete-brochure`, { params });
  }
  static deleteBrochurePdfIT(params) {
    return client.delete(`/delete-pdf-it-brochure`, { params });
  }
  static deleteBrochurePdfDE(params) {
    return client.delete(`/delete-pdf-de-brochure`, { params });
  }
}

export { BrochureServices };
